import './SidePanel.scss'
const SidePanel = ({ open, onClose, children, className = '' }) => {
        return (
            <div className={`side-panel ${open ? "open ${className}" : ""} `}>
                <div className="side-panel-content main-color">
                    <button className="close-btn" onClick={onClose}>✕</button>
                    {children}
                </div>
            </div>
        );
    };
export default SidePanel;